import { getLocaleDateFormat } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';

@Component({
  selector: 'app-scenbeac-sens-cons',
  templateUrl: './scenbeac-sens-cons.component.html',
  styleUrls: ['./scenbeac-sens-cons.component.css']
})
export class ScenbeacSensConsComponent extends BaseComponent  implements OnInit {

  scenbeaconsensors: any = []
  scenbeaconsensorsdisplay: any = []
  organizations: any = []
  sortArray: any = []

  showConsistency = false
  constructor(injector: Injector) { super(injector) }

  async ngOnInit() {
    this.loader.show()
    await this.getData()
    this.loader.hide()
  }
  async getData() {
    this.organizations = await this.db.get("organization","GetOrganizations")
    this.scenbeaconsensors = await this.db.get("Scenariobeaconsensor", "GetScenarioBeaconSensorsWithNames")
    this.scenbeaconsensors.forEach((s:any)=>{
      let org = this.organizations.find((o:any)=> o.id == s.beaconOrganizationId)
      s.beaconOrgName = org == null ? "" : org.name
    })
    this.scenbeaconsensorsdisplay = this.scenbeaconsensors
  }

  sortCol(fieldname: string){
    this.sortGeneric(this.scenbeaconsensorsdisplay, fieldname, this.sortArray)
  }
  showAll(){
    this.scenbeaconsensorsdisplay = this.scenbeaconsensors
  }
  showInconsitency(){
    this.scenbeaconsensorsdisplay = this.scenbeaconsensors.filter((s:any) => s.beaconOrganizationId != s.scenarioOrganizationId);
  }
  async delete(s:any){
    await this.db.delete("Scenariobeaconsensor","deleteScenarioBeaconSensor",{id: s.id})
    s.id = 0
    this.toast.info("Record deleted")
  }
  async refresh(){
    this.loader.show()
    await this.getData()
    this.loader.hide()
  }
  async reassign(s:any){
    this.loader.show()
    let beaconId = s.beaconId
    let scenarioOrgId = s.scenarioOrganizationId
    let beacon:any = await this.db.get("beacon","getBeacon",{id: beaconId})
    beacon.organizationId = scenarioOrgId
    await this.db.post("beacon","postBeacon",beacon)
    await this.getData()
    this.loader.hide()
  }
  

}
